package one.healthium.onboarding.domain.screens

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.onboarding.domain.configs.ScreenConfig

@Serializable
data class ScreenDefinition(
    @SerialName("id") val id: String? = null,
    @SerialName("show_progress_bar") val showProgressBar: Boolean = true,
    @SerialName("profile_key") val profileKey: String? = null,
    @SerialName("config") val config: ScreenConfig,
)
